import styled from 'styled-components'
import { rem } from 'polished'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
const SkeletonContainer = styled.div`
  padding: ${rem(8)} ${rem(12)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
`

interface Props {
  className?: string
}

function OfferDescriptionLoadingSkeleton({ className }: Props) {
  return (
    <SkeletonContainer className={className}>
      <TextLoadingBox typography="body-medium" width="100%" lines={1} />
    </SkeletonContainer>
  )
}

export default OfferDescriptionLoadingSkeleton
